import * as React from "react"
import * as TogglePrimitive from "@radix-ui/react-toggle"
import { cva } from "class-variance-authority";

import { cn } from "lib/utils"

// `default` variant matches the project's MUI theme override on
// MuiToggleButton + MuiToggleButtonGroup: always-visible 1px border, white bg,
// #0095FF (brand-buttonActive) tinted background + brand-coloured border + text
// when selected. Selected item is raised on z-index so adjacent borders don't
// hide its coloured edge (relevant inside a `<ToggleGroup>` where items are
// joined and overlap borders).
const toggleVariants = cva(
  "relative inline-flex items-center justify-center gap-2 rounded-md text-sm font-normal whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "border border-borderGrey bg-white hover:bg-neutral-50 data-[state=on]:border-brand-buttonActive data-[state=on]:bg-brand-buttonActive/15 data-[state=on]:text-brand-buttonActive data-[state=on]:font-medium data-[state=on]:z-10",
        outline:
          "border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground",
        solid:
          "bg-transparent hover:bg-muted hover:text-muted-foreground data-[state=on]:bg-accent data-[state=on]:text-accent-foreground",
      },
      size: {
        default: "h-9 px-3 min-w-9",
        sm: "h-8 px-2 min-w-8",
        lg: "h-10 px-4 min-w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Toggle = React.forwardRef(({ className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={cn(toggleVariants({ variant, size, className }))}
    {...props} />
))

Toggle.displayName = TogglePrimitive.Root.displayName

export { Toggle, toggleVariants }
